module.exports = __webpack_public_path__ + "img/lyris-color.dab607c0.svg";